module.exports = __webpack_public_path__ + "files/c3c1bc445ce164b677aa9779ec9478ff.png";